import { CheckIcon, Loader2 } from "lucide-react";

interface CompletedRedirectPanelProps {
  title: string;
  body: string;
  /** What happens next, shown under the spinner. */
  progressNote: string;
}

/** The green-tick "done" state of a bank dialog, with a spinner while the page moves on. */
export function CompletedRedirectPanel({ title, body, progressNote }: CompletedRedirectPanelProps) {
  return (
    <div className="py-4 text-center space-y-4">
      <div className="mx-auto w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
        <CheckIcon className="h-6 w-6 text-green-600" />
      </div>
      <h3 className="text-lg font-medium">{title}</h3>
      <p>{body}</p>
      <Loader2 className="mx-auto h-5 w-5 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">{progressNote}</p>
    </div>
  );
}
